import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Error } from 'components/common/Form.js';
import PasswordMask from 'components/components/common/PasswordMask';
import InputPhoneNr from 'components/components/common/forms/InputPhoneNr';
import axios from 'components/AppRequest';
import _ from 'lodash';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import isEmpty from 'lodash/isEmpty';
import withRouter from 'components/components/common/withRouter';
import { setUserLogged } from 'components/actions/authActions'
import { connect } from 'react-redux';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import {
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import mergeErrors from 'components/helpers/mergeErrors';
import TransHelper from 'components/common/translations/TransHelper';

function SampleEyeShow() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye']}
      title="Show"
    />
  );
}

function SampleEyeHide() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye-slash']}
      title="Hide"
    />
  );
}

class LoginForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.inputPhoneRef = React.createRef();
  }

  state = {
    isLoading: false,
    phone: '',
    phoneCountry: { value: "norway", label: "+47", code: "NO" },
    password: '',
    errors: {}
  }

  trans = (key,pref  = "content.userData.loginForm") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  transNotify = (type) => {
    return this.trans(type,'content.notifications.loginForm');
  }

  changePhoneNumber = (value) => {
    this.setState({ "phone": value });
  }

  changePassword = (e) => {
    var value = e.target.value;
    this.setState({ "password": value });
  }

  changePhoneCountry = (phoneCountryValue) => {
    this.setState({ "phoneCountry": phoneCountryValue });
  }

  goNext = (e) => {
    this.setState({ isLoading: true, errors: {} }, () => {
      if (this.isFormValid()) {
        //login
        var wholePhone = this.state.phoneCountry.label + this.state.phone;
        var params = { username: wholePhone, password: this.state.password };
        axios.post('/pwa/security/login', params)
          .then(response => {
            LocalStorageHelper.saveToken(response.data.token);
            this.props.setUserLogged(response.data);
            this.props.createSuccessNotification({
              message: this.transNotify('success')
            });
            TransHelper.redirect(this.props, 'routes.url.summary');
          })
          .catch(err => {
            this.props.createErrorNotification({
              title: this.transNotify('error'),
              message: mergeErrors(err.response.data.error)
            });
            this.setState({ isLoading: false });
          });
      } else {
        //show errors
        this.setState({ errors: this.getFormErrors(), isLoading: false });
      }
    });
  }

  isFormValid = () => {
    var errors = this.getFormErrors();
    return isEmpty(errors);
  }

  getFormErrors() {
    var hash = {};
    if (this.state.password.length === 0) {
      hash['password'] = this.trans('passwordBlank','content.errors.auth.loginForm');
    }
    if (this.inputPhoneRef.current.validateForm()) {
      hash['phone'] = this.inputPhoneRef.current.validateForm();
    }
    return hash;
  }

  render() {
    const { errors, phone, phoneCountry, password } = this.state;
    return (
      <form>
        <fieldset>
          <legend className="visuallyhidden">Personal Info Form</legend>
          <p className="text-center" style={{ margin: '-20px 0 30px' }}>
            {this.trans('accountInfo')} <a onClick={this.props.toggleFormState} href="">
              {this.trans('register')}
            </a>
          </p>

          <ul className="list-fields list-none" style={{ marginBottom: '40px' }}>
            <li className="list-fields__item">
              <InputPhoneNr
                ref={this.inputPhoneRef}
                changePhoneCountry={this.changePhoneCountry}
                changePhoneNumber={this.changePhoneNumber}
                errorPhone={errors.phone}
                phoneNumber={phone}
                phoneCountry={phoneCountry}
                locale={this.props.locale}
                />
            </li>
            <li className="list-fields__item">
              <label htmlFor="password">{this.trans('passwordLabel')}</label>
              <PasswordMask
                id="password"
                name="password"
                value={password}
                onChange={this.changePassword}
                showButtonContent={<SampleEyeShow />}
                hideButtonContent={<SampleEyeHide />}
                buttonClassName="button--toggle"
                className="button-toggle-wrap"
              />
              <Error error={errors.password} />
            </li>
          </ul>

          {this.state.isLoading
            ?
            <LoadingSpinner className="button button--outline button--expand" />
            :
            <button
              className="button button--outline button--expand"
              onClick={this.goNext}
            >
            {this.trans('next','content.common')}
            </button>
          }
        </fieldset>
      </form>

    );
  }
}

const mapDispatchToProps = {
  setUserLogged,
  createSuccessNotification,
  createErrorNotification
};

export default withRouter(
  connect(null, mapDispatchToProps)
    (LoginForm)
);
